import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { User } from 'src/app/models/User';
import { GlobalMethodsService } from '../../../../services/global-methods.service';
import { Instruction } from 'src/app/models/Instruction';
import { ProfileInstallationService } from 'src/app/services/commons/profile-installation.service';
import { DefaultModalComponent } from '../../default-modal/default-modal.component';
import { GlobalVariablesService } from '../../../../services/global-variables.service';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
@Component({
  selector: 'app-key',
  templateUrl: './key.component.html',
  styleUrls: ['./key.component.scss'],
})
export class KeyComponent implements OnInit, OnDestroy {

  public status: number = 1;
  public title: string;
  public subtitle: string;
  public keyName: string;
  public titleStatus1: string;
  public subtitleStatus1: string;
  public titleStatus2: string;
  public titleStatus3: string;
  public subtitleStatus3: string;
  @Input('userName') userName: string;
  @Input('user') user: User;
  @Input('s_ins') s_ins: number;
  private setIntID: any;
  private tagNum = '';
  public seconds = 35;
  private isServiceBusy = false;

  constructor(private modalCtrl: ModalController,
    public gms: GlobalMethodsService,
    public gvs: GlobalVariablesService,
    private profileInstallationService: ProfileInstallationService,
    private defaultModalComponent: DefaultModalComponent,
    private translate: TranslateConfigService) { }

  async ngOnInit() {
    await this.gms.loading();
    await this.loadTexts();
    if (this.user.tag_num !== '') {
      this.status = 3;
      this.title = this.titleStatus3;
      this.subtitle = this.subtitleStatus3;
    } else {
      this.title = this.titleStatus1;
      this.subtitle = this.subtitleStatus1;
    }
   this.modalCtrl.dismiss(false, '', 'loadSpinner');
    if (this.status === 1) {
      setTimeout(async () => { await this.checkConfDevice(), 1500 });
    }
  }

  ionViewWillEnter(){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Configurar Llave', contentGroup: 'Configurar Llave'}); 
  }

  ngOnDestroy() {
    if (this.setIntID) {
      clearInterval(this.setIntID);
    }
  }

  async dismiss(confirm: boolean, modalID: string , result?: boolean, user?: User) {
    await this.modalCtrl.dismiss({ confirm: confirm, result: result, user: user }, '', modalID);
  }

  async loadTexts() {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      let instructions: Instruction[] = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 35, 'SIC0200_0110', 'users');
      this.titleStatus1 = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';
      instructions = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 36, 'SIC0200_0110', 'users');
      this.subtitleStatus1 = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';
      instructions = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 37, 'SIC0200_0110', 'users');
      this.titleStatus2 = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';
      instructions = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 38, 'SIC0200_0110', 'users');
      this.titleStatus3 = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';
      instructions = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 39, 'SIC0200_0110', 'users');
      this.subtitleStatus3 = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async close() {
    if (this.status === 1) {
      await this.dismiss(false,'keyModal', false, this.user);
    } else {
      await this.dismiss(true,'keyModal', true, this.user);
    }
  }

  async deleteKey() {
    if (this.isServiceBusy) {
      return;
    }
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      this.isServiceBusy = true;
      await this.gms.loading();
      let newUser: User = JSON.parse(JSON.stringify(this.user));
      newUser.tag_ind = '';
      newUser.tag_num = '';
      const response = await this.profileInstallationService.cAppuserUserUpd(this.s_ins, newUser, 4, 'keyComponent', this.userName);
      if (response === undefined) {
        return;
      }
      if (response) {
        await this.dismiss(true,'keyModal', true, newUser);
      } else {
        await this.dismiss(true,'keyModal', false, newUser);
      }
      this.modalCtrl.dismiss(false, '', 'loadSpinner');
      this.isServiceBusy = false;
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async checkConfDevice() {
    await this.gms.loading();
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      const response = await this.profileInstallationService.cAppuserUserQr(this.user.email, this.s_ins,
        this.user.s_cont, this.user.cix, '', 4, 'keyComponent');
      if (response === undefined) {
        this.modalCtrl.dismiss(false, '', 'loadSpinner');
        return;
      }
      if (response) {
        this.setIntID = setInterval(async () => {
          if (this.tagNum === '') {
            if (this.seconds > 0) {
              this.tagNum = await this.profileInstallationService.gAppuserDeviceConfigured(this.user.email, this.s_ins, this.user.s_cont,
                this.user.cix, 4, 'keyComponent');
              if (this.tagNum === undefined) {
                clearInterval(this.setIntID);
                this.modalCtrl.dismiss(false, '', 'loadSpinner');
                return;
              }
              this.seconds -= 2;
            }
            else {
              clearInterval(this.setIntID);
              this.seconds = 35;
              this.modalCtrl.dismiss(false, '', 'loadSpinner');
            this.gms.analyticsTrackEvent('event_key', {eventCategory: 'SICOR/Llave', eventAction: 'Error/Llave Configurada OK'});
              await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.confDeviceKo'),
                'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
            }
          } else {
            clearInterval(this.setIntID);
            this.seconds = 35;
            let tempUser: User = JSON.parse(JSON.stringify(this.user));
            tempUser.tag_ind = 'X';
            tempUser.tag_num = this.tagNum;
            const newUser = await this.updateConfDevice(tempUser);
            if (newUser === undefined) {
              return;
            }
            if (newUser != null) {
              this.title = this.titleStatus2;
              this.subtitle = '';
              this.status = 2;
              this.user = newUser;
            }
            this.gms.analyticsTrackEvent('event_key', {eventCategory: 'SICOR/Llave', eventAction: 'Accion/Llave Configurada OK'});
            this.modalCtrl.dismiss(false, '', 'loadSpinner');
          }
        }, 2000);
      }
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async updateConfDevice(user: User) {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      return await this.profileInstallationService.cAppuserUserUpd(this.s_ins, user, 4, 'keyComponent', this.userName);
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async modifyKey() {
    await this.gms.loading();
    let tempUser: User = JSON.parse(JSON.stringify(this.user));
    tempUser.tag_ind = 'X';
    tempUser.tag_num = '';
    const newUser = await this.updateConfDevice(tempUser);
    if (newUser === undefined) {
      return;
    }
    if (newUser != null) {
      this.user = newUser;
      await this.checkConfDevice();
    }
    this.modalCtrl.dismiss(false, '', 'loadSpinner');
  }

}
